import React from 'react';
import PropTypes from 'prop-types';
import TopNavBar from "../TopNavBar/TopNavBar";
import classes from "../MobileAppPreview.module.scss";

export default function SplashScreen({ background, logo, logoWidth, logoHeight }) {
    return (
        <div className={classes.splashScreenWrapper}>
            <div className={classes.dynamicIsland} />
            <TopNavBar isSplashAndSignInUpPage />

            <div className={classes.splashContainer}>
                {background ? (
                    <img
                        src={background}
                        alt="Background"
                        className={classes.splashBackground}
                    />
                ) : null}
                {logo ? (
                    <img
                        src={logo}
                        alt="Logo"
                        className={classes.splashLogo}
                        style={{ 
                            width: logoWidth ? `${logoWidth}px` : 'auto',
                            height: logoHeight ? `${logoHeight}px` : 'auto',
                            aspectRatio: logoWidth && logoHeight ? `${logoWidth}/${logoHeight}` : 'auto'
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
}

SplashScreen.propTypes = {
    background: PropTypes.string,
    logo: PropTypes.string,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number,
};